// 商品ページにギフトオプション追加_2026.4.15_佐藤

// gift-option.js

// 役割:
// - ラッピングUIの選択状態を管理
// - 選択内容を hidden input に保存
// - add to cart 自体は行わない
//
// 前提 Liquid:
// - radio name="gift_option"
// - value="none" / "add"
// - add側に
//   data-gift-variant-id
//   data-property-name
//   data-property-value
//
// hidden input に保存する値:
// - properties[_gift_selected]         : "none" / "add"
// - properties[_gift_variant_id]       : gift variant id
// - properties[_gift_type_label]       : ギフトBOX / ギフト巾着
// - properties[_gift_display_value]    : あり
//
// これらは後段の gift-add-interceptor.js が読む

(function () {
  'use strict';

  function log(...args) {
    console.log('[gift-option]', ...args);
  }

  function getGiftRoots() {
    return Array.from(document.querySelectorAll('.gift-option-wrapper'));
  }

  function getForm(root) {
    return root.closest('form');
  }

  function getSelectedGiftOption(root) {
    return root.querySelector('input[name="gift_option"]:checked');
  }

  function ensureHiddenInput(form, name) {
    let input = form.querySelector(`input[name="${CSS.escape(name)}"][data-gift-hidden="true"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-gift-hidden', 'true');
      form.appendChild(input);
    }
    return input;
  }

  function updateHiddenInputs(root) {
    const form = getForm(root);
    if (!form) return;

    const selected = getSelectedGiftOption(root);
    if (!selected) return;

    const selectedValue = selected.value || 'none';
    const giftVariantId = selected.dataset.giftVariantId || '';
    const giftTypeLabel = selected.dataset.propertyName || '';
    const giftDisplayValue = selected.dataset.propertyValue || '';
    const displayText = selected.dataset.displayText || '';

    ensureHiddenInput(form, 'properties[_gift_selected]').value = selectedValue;
    ensureHiddenInput(form, 'properties[_gift_variant_id]').value = giftVariantId;
    ensureHiddenInput(form, 'properties[_gift_type_label]').value = giftTypeLabel;
    ensureHiddenInput(form, 'properties[_gift_display_value]').value = giftDisplayValue;

    const displayLegend = root.querySelector('#gift-selection-display');
    const displayUI = root.querySelector('#gift-selection-display-ui');

    if (displayLegend) displayLegend.textContent = displayText;
    if (displayUI) displayUI.textContent = displayText;

    log('updated hidden inputs', {
      selectedValue,
      giftVariantId,
      giftTypeLabel,
      giftDisplayValue
    });
  }

  function bindRoot(root) {
    if (root.dataset.giftOptionBound === 'true') return;
    root.dataset.giftOptionBound = 'true';

    const options = root.querySelectorAll('input[name="gift_option"]');
    if (!options.length) return;

    options.forEach(option => {
      option.addEventListener('change', function () {
        if (!this.checked) return;
        updateHiddenInputs(root);
      });
    });

    // 初期状態も反映
    updateHiddenInputs(root);
  }

  function init() {
    const roots = getGiftRoots();
    roots.forEach(bindRoot);
    log('initialized roots', roots.length);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();